'use client';

import { c as _c } from "react/compiler-runtime";
import ContactUsForm from '@/components/common/form/ContactUsForm';
import { useRef } from 'react';
export function ContactFormSection() {
  const $ = _c(1);
  const formRightRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="lg:col-span-8" ref={formRightRef}><ContactUsForm formRightRef={formRightRef} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}